import { render } from "./AboutCont.vue?vue&type=template&id=243f74fa"
import script from "./AboutCont.vue?vue&type=script&lang=js"
export * from "./AboutCont.vue?vue&type=script&lang=js"

import "./AboutCont.vue?vue&type=style&index=0&id=243f74fa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__